/**
 * Piletilevi report-api services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { PaymentTypeEnum } from '../model/paymentTypeEnum';
// @ts-ignore
import { ResponseError } from '../model/responseError';
// @ts-ignore
import { SalespointReportPromoterScope } from '../model/salespointReportPromoterScope';
// @ts-ignore
import { SalespointReportScopeEnum } from '../model/salespointReportScopeEnum';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class CsvService {

    protected basePath = 'http://localhost/report';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get event commission fees for bo3 events in csv format
     * @param id 
     * @param language 
     * @param saleStart User can choose the start date of a period. All fees of which operations start in that period are displayed.
     * @param saleEnd User can choose the end date of a period. All fees of which operations that end in that period are displayed.
     * @param legalPersonId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEventCommissionFeesCsv(id: number, language: string, saleStart?: string, saleEnd?: string, legalPersonId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<string>;
    public getEventCommissionFeesCsv(id: number, language: string, saleStart?: string, saleEnd?: string, legalPersonId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<HttpResponse<string>>;
    public getEventCommissionFeesCsv(id: number, language: string, saleStart?: string, saleEnd?: string, legalPersonId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<HttpEvent<string>>;
    public getEventCommissionFeesCsv(id: number, language: string, saleStart?: string, saleEnd?: string, legalPersonId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getEventCommissionFeesCsv.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling getEventCommissionFeesCsv.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (saleStart !== undefined && saleStart !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleStart, 'saleStart');
        }
        if (saleEnd !== undefined && saleEnd !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleEnd, 'saleEnd');
        }
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }
        if (legalPersonId !== undefined && legalPersonId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>legalPersonId, 'legalPersonId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/csv',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/events/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/commission-fees/csv`;
        return this.httpClient.request<string>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get salespoint sales report in csv format
     * @param targetSalespointId Displays list of salespoints under this legal person. In case of supercentre, displays all direct child salespoints.
     * @param sellerUuid User can filter out by selected salespoint legal person representatives that have role in this salespoint. Salespoint must be selected first.
     * @param saleStart User can choose the start date of a period. All transactions that start in that period are displayed. Max range 35 days.
     * @param saleEnd User can choose the end date of a period. All transactions that end in that period are displayed. Max range 35 days.
     * @param paymentType When selected the transactions are filtered by payment type, otherwise all are returned
     * @param scope Filter is displayed only if user is logged under landcentre, alias salespoint or the salespoint has alias connected.
     * @param promoterScope Toggle whether transactions that were issued to promoters are included or not
     * @param eventId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salespointSalesCsvAsEmailGet(targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any>;
    public salespointSalesCsvAsEmailGet(targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<any>>;
    public salespointSalesCsvAsEmailGet(targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<any>>;
    public salespointSalesCsvAsEmailGet(targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (targetSalespointId !== undefined && targetSalespointId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>targetSalespointId, 'targetSalespointId');
        }
        if (sellerUuid !== undefined && sellerUuid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sellerUuid, 'sellerUuid');
        }
        if (saleStart !== undefined && saleStart !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleStart, 'saleStart');
        }
        if (saleEnd !== undefined && saleEnd !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleEnd, 'saleEnd');
        }
        if (paymentType !== undefined && paymentType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>paymentType, 'paymentType');
        }
        if (scope !== undefined && scope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>scope, 'scope');
        }
        if (promoterScope !== undefined && promoterScope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>promoterScope, 'promoterScope');
        }
        if (eventId !== undefined && eventId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventId, 'eventId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/salespoint/sales/csv-as-email`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get salespoint sales report in csv format
     * @param language 
     * @param targetSalespointId Displays list of salespoints under this legal person. In case of supercentre, displays all direct child salespoints.
     * @param sellerUuid User can filter out by selected salespoint legal person representatives that have role in this salespoint. Salespoint must be selected first.
     * @param saleStart User can choose the start date of a period. All transactions that start in that period are displayed. Max range 35 days.
     * @param saleEnd User can choose the end date of a period. All transactions that end in that period are displayed. Max range 35 days.
     * @param paymentType When selected the transactions are filtered by payment type, otherwise all are returned
     * @param scope Filter is displayed only if user is logged under landcentre, alias salespoint or the salespoint has alias connected.
     * @param promoterScope Toggle whether transactions that were issued to promoters are included or not
     * @param eventId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public salespointSalesCsvGet(language: string, targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<string>;
    public salespointSalesCsvGet(language: string, targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<HttpResponse<string>>;
    public salespointSalesCsvGet(language: string, targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<HttpEvent<string>>;
    public salespointSalesCsvGet(language: string, targetSalespointId?: number, sellerUuid?: string, saleStart?: string, saleEnd?: string, paymentType?: PaymentTypeEnum, scope?: SalespointReportScopeEnum, promoterScope?: SalespointReportPromoterScope, eventId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv' | 'application/json', context?: HttpContext}): Observable<any> {
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling salespointSalesCsvGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (targetSalespointId !== undefined && targetSalespointId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>targetSalespointId, 'targetSalespointId');
        }
        if (sellerUuid !== undefined && sellerUuid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sellerUuid, 'sellerUuid');
        }
        if (saleStart !== undefined && saleStart !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleStart, 'saleStart');
        }
        if (saleEnd !== undefined && saleEnd !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleEnd, 'saleEnd');
        }
        if (paymentType !== undefined && paymentType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>paymentType, 'paymentType');
        }
        if (scope !== undefined && scope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>scope, 'scope');
        }
        if (promoterScope !== undefined && promoterScope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>promoterScope, 'promoterScope');
        }
        if (language !== undefined && language !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>language, 'language');
        }
        if (eventId !== undefined && eventId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventId, 'eventId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (bearerAuth) required
        localVarCredential = this.configuration.lookupCredential('bearerAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/csv',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/salespoint/sales/csv`;
        return this.httpClient.request<string>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
